import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import WebFont from 'webfontloader';
import { toast } from 'react-toastify';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import TagManager from "react-gtm-module"
import 'react-toastify/dist/ReactToastify.css';
import PersistStore from "./store/store";
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

/**
 * Sentry monitoring for performance and crashes
 * The release variable can't have slashes in it (won't load in sentry console)
 */
Sentry.init({
  dsn: "https://a596108d118a43969088cecf3e6c2043@o574936.ingest.sentry.io/5726558",
  integrations: [new Integrations.BrowserTracing()],
  release: `${(process.env.REACT_APP_GIT_SHA || "no-release-set").replace("heads/", "").replace(/\//g, "-")}`,
  environment: process.env.REACT_APP_ENVIRONMENT,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: process.env.REACT_APP_SENTRY_TRACE_RATE,
});

/**
 * Google Tag Manager
 */
const tagManagerArgs = {
  gtmId: 'GTM-PBQCVND'
}
TagManager.initialize(tagManagerArgs);

WebFont.load({
  google: {
    families: ['PT Sans:400,400i,700,700i']
  }
});

toast.configure({
  autoClose: 5000,
  draggable: false,
  //etc you get the idea
});

ReactDOM.render(
  <Provider store={PersistStore().store}>
    <PersistGate loading={null} persistor={PersistStore().persistor}>
      <Router>
        <App />
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
